import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertsService } from '@services/alerts.service';
import { TranslationService } from './translation.service';
import { EnvironmentService } from './environment.service';
import { HttpUtilService } from '@services/http-util.service';

// export interface CoursesNavChildItem {
//   link: string;
//   title: string;
//   translation_key?: string;
//   icon?: string;
// }

@Injectable({
  providedIn: 'root',
})
export class MenuListService {
  // private coursesViewCache: {
  //   contextKey: string;
  //   segments: CoursesNavChildItem[];
  // } | null = null;

  constructor(
    private alertsService: AlertsService,
    private translationService: TranslationService,
    private environmentService: EnvironmentService,
    private http: HttpUtilService,
    private router: Router
  ) {}

  getCourseIdFromRoute(url?: string): string | null {
    const path = url ?? this.router.url.split('?')[0];
    const match = path.match(/\/courses\/(\d+)(\/|$)/);
    return match ? match[1] : null;
  }

  // patchCoursesMenuChildren(
  //   menuItems: any[],
  //   instanceData?: { scaffoldType?: string },
  //   activeFeature?: string
  // ): Observable<void> {
  //   const coursesItem = menuItems?.find((i: any) => i.link === '/courses') as
  //     | { link: string; children?: any[]; loadingChildren?: boolean }
  //     | undefined;
  //   if (!coursesItem) return of(undefined);

  //   const url = this.router.url.split('?')[0];
  //   const isCoursesRoute = url.includes('/courses');
  //   const hasChildren = !!coursesItem.children?.length;
  //   if (!isCoursesRoute && !hasChildren && !coursesItem.loadingChildren) {
  //     return of(undefined);
  //   }

  //   const courseId = this.getCourseIdFromRoute();
  //   if (!courseId) {
  //     if (!hasChildren) return of(undefined);
  //     return new Observable<void>(observer => {
  //       requestAnimationFrame(() => {
  //         coursesItem.children = [];
  //         coursesItem.loadingChildren = false;
  //         observer.next(undefined);
  //         observer.complete();
  //       });
  //     });
  //   }

  //   if (!hasChildren) {
  //     coursesItem.loadingChildren = true;
  //   }

  //   return this.getCoursesNavChildren(
  //     activeFeature,
  //     instanceData?.scaffoldType,
  //     courseId
  //   ).pipe(
  //     tap(children => {
  //       const same =
  //         coursesItem.children?.length === children.length &&
  //         children.length > 0 &&
  //         coursesItem.children![0]?.link === children[0]?.link;
  //       coursesItem.loadingChildren = false;
  //       if (!same) coursesItem.children = children;
  //     }),
  //     map(() => undefined)
  //   );
  // }

  private matchesCondition(
    condition: string,
    reqValue: string,
    contextValue: string | undefined
  ): boolean {
    if (contextValue == null || contextValue === '') {
      return true;
    }
    const match = contextValue === reqValue;
    if (condition === 'equal') return match;
    if (condition === 'notequal') return !match;
    return true;
  }

  // private parseCoursesViewToSegments(
  //   viewResponse: any,
  //   contextValue?: string
  // ): CoursesNavChildItem[] {
  //   if (!Array.isArray(viewResponse) || viewResponse.length === 0) {
  //     return [];
  //   }
  //   const content = viewResponse[0]?.json_data?.content;
  //   if (!Array.isArray(content)) {
  //     return [];
  //   }
  //   const seen = new Set<string>();
  //   const segments: CoursesNavChildItem[] = [];

  //   const walk = (items: any[]) => {
  //     if (!Array.isArray(items)) return;
  //     for (const item of items) {
  //       if (item?.type === 'conditional') {
  //         const condition = item.condition ?? 'equal';
  //         const reqValue = item.req_value;
  //         if (
  //           this.matchesCondition(condition, reqValue, contextValue) &&
  //           Array.isArray(item.content)
  //         ) {
  //           walk(item.content);
  //         }
  //         continue;
  //       }
  //       if (item?.type === 'navigation' && Array.isArray(item.links)) {
  //         for (const l of item.links) {
  //           if (l?.link && !seen.has(l.link)) {
  //             seen.add(l.link);
  //             segments.push({
  //               icon: l.icon,
  //               link: l.link,
  //               title: l.text ?? l.link,
  //               translation_key: l.translation_key,
  //             });
  //           }
  //         }
  //       }
  //       if (Array.isArray(item?.content)) {
  //         walk(item.content);
  //       }
  //     }
  //   };

  //   walk(content);
  //   return segments;
  // }

  // private segmentsToChildren(
  //   segments: CoursesNavChildItem[],
  //   courseId: string
  // ): CoursesNavChildItem[] {
  //   return segments.map(s => ({
  //     link: `/courses/${courseId}/${s.link}`,
  //     title: s.title,
  //     translation_key: s.translation_key,
  //     icon: s.icon,
  //   }));
  // }

  // parseCoursesViewNavigation(
  //   viewResponse: any,
  //   contextValue?: string,
  //   courseId?: string
  // ): CoursesNavChildItem[] {
  //   if (!courseId) return [];
  //   const segments = this.parseCoursesViewToSegments(
  //     viewResponse,
  //     contextValue
  //   );
  //   return this.segmentsToChildren(segments, courseId);
  // }

  // getCoursesNavChildren(
  //   activeFeature?: string,
  //   scaffoldType?: string,
  //   courseId?: string
  // ): Observable<CoursesNavChildItem[]> {
  //   if (!courseId) {
  //     return of([]);
  //   }
  //   const contextValue =
  //     activeFeature && activeFeature !== 'all' ? activeFeature : scaffoldType;
  //   const contextKey = `${activeFeature ?? ''}|${scaffoldType ?? ''}`;

  //   if (
  //     this.coursesViewCache &&
  //     this.coursesViewCache.contextKey === contextKey
  //   ) {
  //     return of(
  //       this.segmentsToChildren(this.coursesViewCache.segments, courseId)
  //     );
  //   }

  //   return this.http.request('get', 'api/views?type=courses&mode=read').pipe(
  //     map((response: any) => {
  //       const segments = this.parseCoursesViewToSegments(
  //         response,
  //         contextValue
  //       );
  //       this.coursesViewCache = { contextKey, segments };
  //       return this.segmentsToChildren(segments, courseId);
  //     })
  //   );
  // }

  // ensureCoursesViewCached(
  //   activeFeature?: string,
  //   scaffoldType?: string,
  //   menuItems?: any[]
  // ): Observable<void> {
  //   if (
  //     menuItems?.length &&
  //     !menuItems.some((i: any) => i.link === '/courses')
  //   ) {
  //     return of(undefined);
  //   }
  //   const contextValue =
  //     activeFeature && activeFeature !== 'all' ? activeFeature : scaffoldType;
  //   const contextKey = `${activeFeature ?? ''}|${scaffoldType ?? ''}`;
  //   if (
  //     this.coursesViewCache &&
  //     this.coursesViewCache.contextKey === contextKey
  //   ) {
  //     return of(undefined);
  //   }
  //   return this.http.request('get', 'api/views?type=courses&mode=read').pipe(
  //     map((response: any) => {
  //       const segments = this.parseCoursesViewToSegments(
  //         response,
  //         contextValue
  //       );
  //       this.coursesViewCache = { contextKey, segments };
  //       return undefined;
  //     })
  //   );
  // }

  getGlobalMenu(instanceData, roleData, activeFeature) {
    const hasHomePage = this.environmentService.hasFeature(
      ['datax', 'migration'],
      roleData
    );
    let menuItems = [
      {
        title: 'Home',
        translation_key: 'home',
        link: '/home',
        icon: 'fas fa-home',
        show: (instanceData, roleData) => hasHomePage,
      },
      {
        title: 'Dashboard',
        translation_key: 'dashboard',
        link: '/home',
        icon: 'fas fa-home',
        show: (instanceData, roleData) => {
          return (
            !hasHomePage && this.environmentService.hasFeature(['sis-archive'])
          );
        },
      },
      //   {
      //     title: 'Home',
      //     translation_key: 'home',
      //     link: '/home',
      //     icon: 'fas fa-home',
      //     show: (instanceData, roleData) =>
      //       this.environmentService.hasFeature(['datax', 'migration'], roleData),
      //   },
      //   {
      //     title: 'Dashboard',
      //     translation_key: 'dashboard',
      //     link: '/home',
      //     icon: 'fas fa-home',
      //     show: (instanceData, roleData) => {
      //       return this.environmentService.hasFeature(['sis-archive']);
      //     },
      //   },

      // {
      //   title: "Migrations",
      //   translation_key: "migrations",
      //   link: "/migrations",
      //   icon: 'fas fa-cubes-stacked',
      //   show: (instanceData, roleData) => {
      //     return (
      //       instanceData?.scaffoldType?.includes("migration")&&roleData?.view_admin
      //     );

      //   },
      // },

      {
        title: 'Imports',
        translation_key: 'imports',
        link: '/imports',
        icon: 'fas fa-cubes-stacked',
        tourId: 'create-import,create-integration',
        stepId: 'step-2,step-2',
        position: 'bottom-14,bottom-14',
        show: (instanceData, roleData) => {
          return (
            this.environmentService.hasFeature(
              ['archivev2', 'imports'],
              roleData
            ) &&
            !roleData?.limit_imports &&
            !instanceData.no_self_serve
          );
        },
      },
      {
        title: 'Archive Import',
        translation_key: 'archive_import',
        link: '/archive-import',
        icon: 'fas fa-cubes-stacked',
        show: (instanceData, roleData) => {
          return (
            this.environmentService.hasFeature(
              ['archive', 'archivev2'],
              roleData
            ) &&
            instanceData.system_type === 'blackboard' &&
            roleData?.manage_imports
          );
        },
      },

      {
        title: 'AI Detection',
        translation_key: 'ai_detection',
        link: '/ai-detection-report',
        icon: 'fas fa-computer-classic',
        show: (instanceData, roleData) =>
          this.environmentService.hasFeature('ai-detection', roleData) &&
          !roleData?.['limit_ai-detection'] &&
          roleData?.view_sigma,
      },
      /*   {
        title: "Archive",
        translation_key: "archive",
        link: "/batch-details",
        icon: 'fa fa-container-storage',
        show: (instanceData, roleData) => instanceData?.scaffoldType?.includes('archivev2'),
      }*/
      {
        title: 'Courses',
        link: '/courses',
        translation_key: 'courses',
        icon: 'fas fa-book-open',
        show: (instanceData, roleData) => {
          return (
            this.environmentService.hasFeature(
              ['archivev2', 'ai-detection', 'designer', 'archive', 'courses'],
              roleData
            ) && !roleData?.limit_courses
          );
        },
      },
      {
        title: 'Documents',
        link: '/documents',
        translation_key: 'documents',
        icon: 'fas fa-file-alt',
        show: (instanceData, roleData) => {
          return (
            roleData?.sis_document_access &&
            this.environmentService.hasFeature(
              ['sis-archive', 'documents'],
              roleData
            )
          );
        },
      },
      {
        title: 'People',
        translation_key: 'people',
        link: '/accounts',
        icon: 'fa fa-user-graduate',
        show: (instanceData, roleData) =>
          this.environmentService.hasFeature(
            ['archivev2', 'limit_people', 'sis-archive'],
            roleData
          ) && !roleData?.limit_people,
      },

      {
        title: 'documentation',
        translation_key: 'documentation',
        link: '/documentation',
        icon: 'fa fa-book',
        show: (instanceData, roleData) =>
          this.environmentService.hasFeature(
            ['datax', 'documentation'],
            roleData
          ) && !roleData?.limit_documentation,
        children: this.getDocumentationMenuChildren(),
      },
      {
        title: 'snowflake',
        translation_key: 'snowflake',
        link: '/snowflake',
        icon: 'fa fa-chart-network',
        show: (instanceData, roleData) =>
          this.environmentService.hasFeature(
            ['datax', 'snowflake'],
            roleData
          ) && roleData?.view_snowflake,
      },
      {
        title: 'analytics',
        translation_key: 'analytics',
        link: '/analytics',
        icon: 'fa fa-chart-line',
        show: (instanceData, roleData) =>
          this.environmentService.hasFeature(
            ['datax', 'analytics'],
            roleData
          ) &&
          !roleData?.limit_analytics &&
          (roleData?.view_sigma ||
            roleData?.manage_sigma ||
            roleData?.manage_worksheets),
        children: this.getAnalyticsMenuChildren(roleData),
      },

      {
        title: 'lakehouse',
        translation_key: 'lakehouse',
        link: '/lakehouse',
        icon: 'fa fa-database',
        show: (instanceData, roleData) =>
          this.environmentService.hasFeature(
            ['datax', 'lakehouse'],
            roleData
          ) && !roleData?.limit_lakehouse,
        children: this.getLakehouseMenuChildren(roleData),
      },
      {
        title: 'Tools',
        translation_key: 'tools',
        link: '/lti',
        icon: 'fas fa-link',
        show: (instanceData, roleData) => {
          return (
            roleData?.manage_tools &&
            this.environmentService.hasFeature(['designer', 'tools'], roleData)
          );
        },
      },

      {
        title: 'Configure',
        translation_key: 'configure',
        link: '/data-models',
        icon: 'fas fa-key',
        show: (instanceData, roleData) => roleData?.manage_views,
      },
      {
        title: 'Alerts',
        translation_key: 'alerts',
        link: '/alerts',
        icon: 'fas fa-bell',
        badge: () => {
          return this.alertsService.getActiveCount();
        },
        show: (instanceData, roleData) =>
          this.environmentService.hasFeature(['datax', 'alerts'], roleData) &&
          !roleData?.limit_alerts,
      },
      {
        title: 'Admin',
        translation_key: 'admin',
        link: '/admin',
        icon: 'fas fa-list-alt',
        tourId: 'scaffold-theme-setup',
        stepId: 'step-1',
        position: 'bottom-14',
        show: (instanceData, roleData) => roleData?.view_admin,
        children: this.getAdminMenuChildren(
          roleData,
          activeFeature,
          instanceData
        ),
      },
    ];
    return menuItems.filter(item => {
      return item.show(instanceData, roleData);
    });
  }

  private getAnalyticsMenuChildren(roleData) {
    return [
      {
        translation_key: 'reporting',
        text: 'Reporting',
        title: 'Reporting',
        route: 'reporting',
        link: '/analytics/reporting',
        icon: 'fas fa-chart-pie',
        hidden: !roleData?.view_sigma,
      },
      {
        translation_key: 'worksheets',
        text: 'Worksheets',
        title: 'Worksheets',
        route: 'worksheets',
        link: '/analytics/worksheets',
        icon: 'fas fa-table-cells',
        hidden: !roleData?.manage_worksheets,
      },
    ];
  }

  private getLakehouseMenuChildren(roleData) {
    return [
      {
        translation_key: 'deployments',
        text: 'Deployments',
        title: 'Deployments',
        route: 'deployments',
        link: '/lakehouse/deployments',
        icon: 'fas fa-rocket',
        hidden: false,
      },
      {
        translation_key: 'exports',
        text: 'Exports',
        title: 'Exports',
        route: 'exports',
        link: '/lakehouse/exports',
        icon: 'fas fa-file-export',
        hidden: !roleData?.manage_exports,
      },
      {
        translation_key: 'imports',
        text: 'Imports',
        title: 'Imports',
        route: 'imports',
        link: '/lakehouse/imports',
        icon: 'fas fa-file-import',
        hidden: !roleData?.manage_datax_imports,
      },
      {
        translation_key: 'snapshots',
        text: 'Snapshots',
        title: 'Snapshots',
        route: 'snapshots',
        link: '/lakehouse/snapshots',
        icon: 'fas fa-camera',
        hidden: false,
      },
    ];
  }

  private getDocumentationMenuChildren() {
    return [
      {
        translation_key: 'catalog',
        text: 'Catalog',
        title: 'Catalog',
        route: 'catalog',
        link: '/documentation/catalog',
        icon: 'fas fa-folder-tree',
        hidden: false,
      },
      {
        translation_key: 'explore',
        text: 'Explore',
        title: 'Explore',
        route: 'explore',
        link: '/documentation/explore',
        icon: 'fas fa-compass',
        hidden: false,
      },
      {
        translation_key: 'relationships',
        text: 'Relationships',
        title: 'Relationships',
        route: 'relationships',
        link: '/documentation/relationships',
        icon: 'fas fa-diagram-project',
        hidden: false,
      },
      {
        translation_key: 'lineage',
        text: 'Lineage',
        title: 'Lineage',
        route: 'lineage',
        link: '/documentation/lineage',
        icon: 'fas fa-sitemap',
        hidden: false,
      },
      {
        translation_key: 'business_glossary',
        text: 'Business Glossary',
        title: 'Business Glossary',
        route: 'business-glossary',
        link: '/documentation/business-glossary',
        icon: 'fas fa-book-bookmark',
        hidden: false,
      },
    ];
  }

  public getAdminMenuChildren(roleData, activeFeature, instanceData) {
    return [
      {
        translation_key: 'account_policies',
        text: 'Account Policies',
        title: 'Account Policies',
        route: 'user-accounts',
        link: '/admin/user-accounts',
        icon: 'fas fa-user-shield',
        hidden: false,
      },
      {
        translation_key: 'users_and_roles',
        text: 'Users & Roles',
        title: 'Users & Roles',
        route: 'users-and-roles',
        link: '/admin/users-and-roles',
        icon: 'fas fa-users',
        hidden: !roleData || !roleData?.manage_users,
        tourId: 'inviting-users',
        stepId: 'step-2',
        position: 'bottom-14',
      },
      {
        translation_key: 'data_access',
        text: 'Data Access',
        title: 'Data Access',
        route: 'data-access',
        link: '/admin/data-access',
        icon: 'fas fa-database',
        hidden:
          !roleData ||
          !roleData?.manage_roles ||
          (activeFeature !== 'all' && activeFeature !== 'datax'),
      },
      {
        translation_key: 'integrations',
        text: 'Integrations',
        title: 'Integrations',
        route: 'integrations',
        link: '/admin/integrations',
        icon: 'fas fa-plug',
        hidden: !roleData?.view_integrations,
      },
      {
        translation_key: 'styling',
        text: 'Styling',
        title: 'Styling',
        route: 'styling',
        link: '/admin/styling',
        icon: 'fas fa-palette',
        hidden: false,
        tourId: 'scaffold-theme-setup',
        stepId: 'step-2',
        position: 'right-top',
      },
      {
        translation_key: 'SSO',
        text: 'SSO',
        title: 'SSO',
        route: 'sso',
        link: '/admin/sso',
        icon: 'fas fa-key',
        hidden: !roleData?.view_sso,
      },
      {
        translation_key: 'data_retention',
        text: 'Data Retention',
        title: 'Data Retention',
        route: 'dataretention',
        link: '/admin/dataretention',
        icon: 'fas fa-calendar',
        hidden:
          !roleData?.manage_data_retention ||
          (activeFeature !== 'all' && activeFeature !== 'archivev2'),
      },
      {
        translation_key: 'user_data',
        text: 'User Data',
        title: 'User Data',
        route: 'userdata',
        link: '/admin/userdata',
        icon: 'fas fa-user-cog',
        hidden:
          !roleData?.manage_user_data_removal ||
          (activeFeature !== 'all' && activeFeature !== 'archivev2'),
      },
    ];
  }

  getMenuFooter(instanceData, roleData) {
    let footerMenu = [
      {
        type: 'modal',
        icon: 'fa-solid fa-question',
        modal: 'quick_help',
        title: this.translationService.getTranslatedContent(
          'quick_help',
          'Quick Help'
        ),
        translation_key: 'quick_help',
        show: (instanceData, roleData) =>
          roleData?.view_admin &&
          !instanceData?.no_self_serve &&
          this.environmentService.hasFeature(
            ['archivev2', 'quick_help'],
            roleData
          ),
      } /*{
            {
        type: "modal",
        icon: "fa-regular fa-hat-wizard fa-fw",
        modal: "wizard",
        title: "Wizard",
        translation_key: "wizard",
        show: (instanceData, roleData) => roleData?.view_admin && instanceData?.scaffoldType === "archivev2",
      },*/,

      // {
      //   type: 'link',
      //   link: 'changes',
      //   translation_key: 'changes',
      //   icon: 'fa-regular fa-memo-circle-info',
      //   title: 'Changes',
      //   show: (instanceData, roleData) => true,
      // },
      {
        type: 'url',
        url: 'https://app.conveyor.com/profile/k16-solutions',
        translation_key: 'trust_portal',
        icon: 'fa-solid fa-shield-check',
        title: 'Trust Portal',
        show: (instanceData, roleData) => true,
      },
      /*  {
        type: "link",
        link: "security",
        translation_key: "security",
        icon: "fa-solid fa-shield-check",
        title: "Security",
        show: (instanceData, roleData) => true,
      },*/
    ];
    return footerMenu.filter(item => {
      return item.show(instanceData, roleData);
    });
  }
}
